import { useTalkT } from '@/talk/useTalkT'

export function HelpSupportBadge({ compact = false }: { compact?: boolean }) {
  const t = useTalkT()
  return (
    <span
      className={`font-bold tracking-wide rounded bg-slate-800 text-white shrink-0 ${
        compact ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-0.5'
      }`}
    >
      {t('talk_support')}
    </span>
  )
}
